<script setup lang="ts">
defineProps<{
    toggle: (_value?: boolean) => void
}>()

/**
 * Translations.
 */
const { t } = useI18n()
</script>

<template>
    <button
        class="h-full align-middle"
        type="button"
        data-tutorial-step="2"
        :data-tutorial-text="t('tutorial-toolbar-open')"
        data-tutorial-on-step-2="click"
        data-tutorial-on-complete="close"
        data-tutorial-on-cancel="close"
        @close="toggle(false)"
        @open="toggle(true)"
        @click="toggle()"
    >
        <AdjustmentsVerticalIcon
            class="h-8 rounded border border-deep-blue p-1"
        />
    </button>
</template>